
document.addEventListener('DOMContentLoaded', publicJs)

const currentLocation = window.location;

function publicJs() {

    /**
     * Modals
     */

    function addModalListeners() {
        let modalOpenButtons = document.querySelectorAll('.modal-open');
        if(modalOpenButtons) {
            modalOpenButtons.forEach((i) => {
                i.addEventListener('click', openModal);
            })
        }
    }

    waitForElm('.curr-toggle').then((e) => {
        addModalListeners();
    })

    addModalListeners();

    function openModal(e) {
        e.preventDefault();
        let target = e.target.getAttribute('data-target');
        console.log(target);
        let targetEl = document.querySelector(target);
        if(targetEl) {
            targetEl.classList.add('open');
            window.addEventListener('keyup', maybeCloseModal);
        }
    }

    let closeModals = document.querySelectorAll('.js-modal-close');

    if(closeModals) {
        closeModals.forEach((i) => {
            i.addEventListener('click', closeModal);
        })
    }

    function maybeCloseModal(e) {
        if(e.key == 'Escape') {
            let modal = document.querySelector('.modal.open')
            if(modal) {
                modal.classList.remove('open');
                window.removeEventListener('keyup', maybeCloseModal)
            }
        }
    }

    function closeModal(e) {
        e.preventDefault();
        let modal = e.target.closest('.modal');
        modal.classList.remove('open');
    }

    //--------------------
    // Dashboard Menu toggle
    //--------------------
    var menu_toggle = document.querySelector('#nav-burger');
    var sidemenu = document.querySelector('#app-menu');
    var main = document.querySelector('main');
    var aside = document.querySelectorAll('aside');
    var banner = document.querySelector('.downloadBanner');
    if (menu_toggle) {
        menu_toggle.addEventListener('click', menuToggle);
    }

    function menuToggle() {
        menu_toggle.classList.toggle('open');
        sidemenu.classList.toggle('open');
        main.classList.toggle('shifted');
        if(banner) { banner.classList.toggle('shifted');}
        for (var m = 0; m < aside.length; m++) {
            aside[m].classList.toggle('shifted');
        }
    }

    /**
     * OnboardingProgress
     */

    let onboardingCheckBoxes = document.querySelectorAll('.onboarding input[type="checkbox"]');
    if(onboardingCheckBoxes) {
        let checked = 0;
        onboardingCheckBoxes.forEach((i) => {
            i.addEventListener('change', updateOnboardingProgress);
            if(i.checked) {
                checked++;
            }
        })
        if(document.querySelector('.onboarding .progress')) {
            document.querySelector('.onboarding .progress').setAttribute('data-steps', checked);
        }
    }

    function updateOnboardingProgress(e) {
        let checkedBoxes = document.querySelectorAll('.onboarding input[type="checkbox"]:checked');
        let count = checkedBoxes.length;
        let checked = e.target.checked;
        document.querySelector('.js-onboard-steps-completed').innerText = count;
        document.querySelector('.onboarding .progress').setAttribute('data-steps', count);

        let formdata = new FormData();
        formdata.append('action', 'update_onboarding_progress');
        formdata.append('name', e.target.value);
        formdata.append('user_id', window.user_id);
        formdata.append('value', checked);
        fetch(teachactive.ajaxurl, {
            method: 'POST',
            body: formdata
        }).then(response => response.json())
        .then((jsonData) => {
            if(jsonData.steps_completed == document.querySelectorAll('.onboarding input[type="checkbox"]').length) {
                document.querySelector('.onboarding-banner').remove();
            }
        })
    }

    /* */
    /** Favourites Folders */
    /* */
    let createFolderSubmit = document.querySelector('.js-submit-add-folder');
    if(createFolderSubmit) {
        createFolderSubmit.addEventListener('click', submitCreateFolder);
    }

    function submitCreateFolder(e) {
        e.preventDefault();
        let formdata = new FormData(e.target.closest('form'));
         fetch(teachactive.ajaxurl, {
            method: 'POST',
            body: formdata
        }).then(response => response.json())
        .then((jsonData) => {
            //@todo do something if its the last
            if(jsonData.success) {
                e.target.nextElementSibling.innerText =  jsonData.message;
                setTimeout(function() {
                    window.location.reload()
                }, 5000)

            } else {
                e.target.nextElementSibling.innerText =  jsonData.message
            }
        })
    }


    let folderViewButtons = document.querySelectorAll('.open-folder');
    if(folderViewButtons) {
        folderViewButtons.forEach((i) => {
            i.addEventListener('click', load_folder_lessons);
        })
    }

    function load_folder_lessons(e) {
        e.preventDefault();
        let user_id = e.target.getAttribute('data-user-id');
        let folder = e.target.getAttribute('data-folder');
        let folderName = e.target.getAttribute('data-folder-name');
        let formdata = new FormData();
        formdata.append('user_id', user_id);
        formdata.append('folder', folder);
        formdata.append('action', 'load_folder_lessons');
         fetch(teachactive.ajaxurl, {
            method: 'POST',
            body: formdata
        }).then(response => response.json())
        .then((jsonData) => {
            if(jsonData.success) {
                document.querySelector('.lessons.dashboard-3-cols').innerHTML = jsonData.html
                let breadcrumb = document.querySelector('.folder-heading--breadcrumb');
                breadcrumb.innerText = folderName;
                breadcrumb.classList.add('open');
                let folders = document.querySelector('.folders');
                folders.style.height = '0px';
                resetFolderOptionToggles();
                addModalListeners();
                addLessonListeners();
            } else {
                e.target.nextElementSibling.innerText =  jsonData.message
            }
        })
    }

    resetFolderOptionToggles();

    function resetFolderOptionToggles() {
        let folderOptionToggles = document.querySelectorAll('.js-tooltip-toggle');
        if(folderOptionToggles) {
            folderOptionToggles.forEach((i) => {
                i.addEventListener('click', openFolderOptions);
            })
        }
    }


    function openFolderOptions(e) {
        e.preventDefault();
        let folderName = e.target.getAttribute('data-folder-name');
        let folderNiceName = e.target.getAttribute('data-folder-nicename');
        document.querySelector('input[name="folder_to_rename"]').value = folderNiceName;
        document.querySelector('input[name="folder_name"]').value = folderName;
        e.target.nextElementSibling.classList.add('open');
        window.addEventListener('click', maybeCloseFolderOptions);
    }

    function maybeCloseFolderOptions(e) {
        let target = e.target;
        if(target.classList.contains('option-popup')) {
            e.target.classList.remove('open');
            window.removeEventListener('click', maybeCloseFolderOptions);
        }
    }

    let renamefolderForm = document.querySelector('.folder-rename form')
    if(renamefolderForm) {
        renamefolderForm.addEventListener('submit', updateFolderName);
    }

    function updateFolderName(e) {
        e.preventDefault();
         let formdata = new FormData(e.target);
         fetch(teachactive.ajaxurl, {
            method: 'POST',
            body: formdata
        }).then(response => response.json())
        .then((jsonData) => {
            if(jsonData.success) {
                window.location.reload();
            } else {
                e.target.nextElementSibling.innerText =  jsonData.message
            }
        })
    }

    let folderHome = document.querySelector('.folder-headng--home');
    if(folderHome) {
        folderHome.addEventListener('click', rollbacktoFolders);
    }

    function rollbacktoFolders(e) {
        e.preventDefault();
        document.querySelector('.folders.dashboard-3-cols').style.height = 'auto';
        if(document.querySelector('.lessons')) {
            document.querySelector('.lessons').innerHTML = '';
        }
        document.querySelector('.folder-heading--breadcrumb').classList.remove('open');
        resetFolderOptionToggles();
    }

    let deleteFolderToggles = document.querySelectorAll('.delete-folder-modal');
    if(deleteFolderToggles) {
        deleteFolderToggles.forEach((i) => {
            i.addEventListener('click', openFolderDeleteModal);
        })
    }

    function openFolderDeleteModal(e) {
        let folderNme = e.target.getAttribute('data-folder');
        let folderNiceName = e.target.getAttribute('data-folder-nice-name');
        document.querySelector('.folder-delete .folder-name').innerText = folderNme;
        document.querySelector('.folder-delete .confirm-delete-folder').setAttribute('data-folder', folderNiceName);
    }

    let confirmDelete = document.querySelector('.confirm-delete-folder');
    if(confirmDelete) {
        confirmDelete.addEventListener('click', deleteFolder)
    }

    function deleteFolder(e) {
        e.preventDefault();
         let formdata = new FormData();
         let user = e.target.getAttribute('data-user-id')
         let folder = e.target.getAttribute('data-folder');
         formdata.append('user_id', user)
         formdata.append('folder', folder)
         formdata.append('action', 'delete_folder');
         fetch(teachactive.ajaxurl, {
            method: 'POST',
            body: formdata
        }).then(response => response.json())
        .then((jsonData) => {
            if(jsonData.success) {
                window.location.reload();
            } else {
                e.target.nextElementSibling.innerText =  jsonData.message
            }
        })
    }

    let folderAddToSubmit = document.querySelector('.modal.add-to-folder input[type="submit"]');
    if(folderAddToSubmit) {
        folderAddToSubmit.addEventListener('click', saveToFolder);
    }

     function saveToFolder(e) {
            let folder = document.querySelector('#folder-to-add-to').value;
            document.querySelector('.add-to-folder-message').innerText = '';
            if(!folder) {
                document.querySelector('.add-to-folder-message').innerText = 'Please select a folder';
            } else {
                let lesson = document.querySelector('#leson_to_add_to_folder').value;
                let formdata = new FormData();
                formdata.append('user_id', window.user_id);
                formdata.append('folder', folder);
                formdata.append('lesson_id', lesson);
                formdata.append('action', 'add_to_folder');
                fetch(teachactive.ajaxurl, {
                method: 'POST',
                body: formdata
            }).then(response => response.json())
            .then((jsonData) => {
                if(jsonData) {
                    document.querySelector('.add-to-folder-message').innerText = 'Lesson Added';
                } else {
                    document.querySelector('.add-to-folder-message').innerText = 'There was a problem saving this lesson to the selected folder. Is it in there already?';
                }
            })
            }
        }

    /** Lessons */
    addLessonListeners();
    function addLessonListeners() {

        let deleteLessonToggles = document.querySelectorAll('.delete-lesson-modal');
        if(deleteLessonToggles) {
            deleteLessonToggles.forEach((i) => {
                i.addEventListener('click', openLessonDeleteModal);
            })
        }
    }

    function openLessonDeleteModal(e) {
        let folder = e.target.getAttribute('data-folder');
        let lessonid = e.target.getAttribute('data-lesson-id');
        let lessonNName = e.target.getAttribute('data-lesson-name');
        document.querySelector('.lesson-name').innerText = lessonNName
        document.querySelector('.lesson-delete .confirm-delete-lesson').setAttribute('data-lesson', lessonid);
        document.querySelector('.lesson-delete .confirm-delete-lesson').setAttribute('data-folder', folder);
    }

    let confirmDeleteLesson = document.querySelector('.confirm-delete-lesson');
    if(confirmDeleteLesson) {
        confirmDeleteLesson.addEventListener('click', deleteLesson)
    }

    function deleteLesson(e) {
        e.preventDefault();
         let formdata = new FormData();
         let user = e.target.getAttribute('data-user-id')
         let folder = e.target.getAttribute('data-folder');
         let lesson = e.target.getAttribute('data-lesson');
         formdata.append('user_id', user)
         formdata.append('folder', folder)
         formdata.append('lesson', lesson)
         formdata.append('action', 'delete_lesson');
         fetch(teachactive.ajaxurl, {
            method: 'POST',
            body: formdata
        }).then(response => response.json())
        .then((jsonData) => {
            if(jsonData.success) {
                window.location.reload();
            } else {
                e.target.nextElementSibling.innerText =  jsonData.message
            }
        })
    }

    /*
    /** School Hub Nav */
    /* */

    let schoolHubTabButtons = document.querySelectorAll('.school-hub--nav a');
    if(schoolHubTabButtons) {
        schoolHubTabButtons.forEach((i) => {
            i.addEventListener('click', toggleSchoolHubTab);
        })
    }

    function toggleSchoolHubTab(e) {
        e.preventDefault();
        let targetID = e.target.getAttribute('href');
        let targetTitle = e.target.innerText;
        let target = document.querySelector(targetID);
        if(!target || target.classList.contains('active')) {

        } else {
            let existActive = document.querySelector('.school-hub .content > .active');
            if(existActive) {
                existActive.classList.remove('active');
            }
            let activeButton = document.querySelector('.school-hub--nav a.active');
            if(activeButton) {
                activeButton.classList.remove('active');
            }
            target.classList.add('active');
            e.target.classList.add('active');
            let url = window.location.protocol + '//' + window.location.hostname + '/my-account/school-hub/' + (targetID.replace('#', ''));
            history.pushState({page: targetTitle}, '', url)
        }
    }


    //--------------------
    // Banner Tooltip
    //--------------------
    if (banner) {
        var icon = banner.querySelector('icon');
        if (icon) {
            icon.addEventListener('click', tooltipToggle);
        }

        function tooltipToggle() {
            icon.classList.toggle('active');
        }
    }


    //--------------------
    // account on hold
    //--------------------
    var accountOnHold = document.querySelector('.account-on-hold');
    if (accountOnHold) {
        let lessonPlans = document.querySelectorAll('.on-hold-trigger');
        if(lessonPlans) {
            lessonPlans.forEach((i) => {
                i.addEventListener('click', showOnHoldMessage);
            })
        }
        accountOnHold.addEventListener('click', function () {
            if(accountOnHold.classList.contains('active')) {
                accountOnHold.classList.remove('active');
            }
        });
    }

    function showOnHoldMessage(e) {
        e.preventDefault();
        document.querySelector('.account-on-hold').classList.add('active');
    }

    //--------------------
    // AI
    //-----

    if (document.querySelector('body').classList.contains('my-account')) {
        waitForElm('.open-ai-chat').then((elm) => {

         let aiChatToggle = document.querySelector('#chatbase-bubble-button');

         let chatToggleButton = document.querySelectorAll('.open-ai-chat');
            if (chatToggleButton) {
                chatToggleButton.forEach((i) => {
                    i.addEventListener('click', openaichat)
                })
            }
        });

    }

    function openaichat(e) {
        e.preventDefault();
        let aiChatToggle = document.querySelector('#chatbase-bubble-button');
        aiChatToggle.click();
    }

    function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    observer.disconnect();
                    resolve(document.querySelector(selector));
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }


    function setupChatListener() {
        if(window.chatbase) {
            window.chatbase.addEventListener('assistant-message', (event) => {
                console.log('AI responded:', event.data, event);
                });
        } else {
            setTimeout(setupChatListener, 100);
        }
    }


    //--------------------
    // Curriculum Settings
    //--------------------

    if(document.querySelector('.curriculum-modal .modal-close')) {
        document.querySelector('.curriculum-modal .modal-close').addEventListener('click', function() {
            var currPopup = document.querySelector('.curriculum-modal');
            currPopup.classList.remove('opened');
            let curr = document.querySelector('input[name="curriculum-modal"]:checked').value;
            if (curr) {
                window.curriculum = curr;
            } else {
                window.curriculum = 'English';
            }
        })
    }

    let curriculumSet = document.querySelector('.curriculum-switch');
    if(curriculumSet) {
        curriculumSet.addEventListener('click', saveCurriculumSetting);
    }

    function saveCurriculumSetting(e) {
        e.target.classList.add('submitting');
        let curr = document.querySelector('input[name="curriculum-modal"]:checked').value;
        let user_id = document.querySelector('.curriculum-modal input[name="user_id"]').value;
        let formdata = new FormData();
        formdata.append('action', 'set_curriculum_preference');
        formdata.append('curriculum', curr);
        formdata.append('user_id', user_id);
        fetch(teachactive.ajaxurl, {
            method: 'POST',
            body: formdata
        }).then(response => response.json())
        .then((jsonData) => {
            window.curriculumcurr;
            var currPopup = document.querySelector('.curriculum-modal');
            currPopup.classList.remove('opened');
            setTimeout(function() {
                window.location.reload();
            }, 500);
        })
    }

    //--------------------
    // Vimeo modals
    //--------------------

    let openVimeoModalButtons = document.querySelectorAll('.open-vimeo-modal');
    if(openVimeoModalButtons) {
        openVimeoModalButtons.forEach((i) =>  {
            i.addEventListener('click', openVimeoModal)
        })
    }

    function openVimeoModal(e) {
        var vimeoId = e.target.getAttribute('data-vimeo-id');
        var iframeSrc = 'https://player.vimeo.com/video/' + parseInt(vimeoId) + '?autoplay=1&title=0';
        var iframeCode = '<iframe frameborder="0" src="' + iframeSrc + '"></iframe>';

        let vimeoContainer = document.querySelector('.vimeo-modal');
        let open = vimeoContainer.classList.contains('open');

        let video = vimeoContainer.querySelector('iframe');
        if(video) {
            video.remove();
        }

        vimeoContainer.querySelector('.iframe-container').insertAdjacentHTML('beforeend', iframeCode);
        vimeoContainer.classList.remove('closed')
        vimeoContainer.classList.add('open');
        vimeoContainer.addEventListener('click', maybecloseVimeo)
    }

    function maybecloseVimeo(e) {
        let target = e.target;
        if(target.nodeName != 'IFRAME') {
            let vimeoContainer = document.querySelector('.vimeo-modal');
            let video = vimeoContainer.querySelector('iframe');
            if(video) {
                video.remove();
            }
            vimeoContainer.classList.remove('open');
        }
    }

    let urlSearchParams = new URLSearchParams(window.location.search);
    if(urlSearchParams) {
        if(urlSearchParams.get('video')) {
            let id = urlSearchParams.get('video');
            if(document.querySelector('[data-vimeo-id="'+id+'"]')) {
                document.querySelector('[data-vimeo-id="'+id+'"]').click();
            }
        }
    }

    //--------------------
    //copy to clipboard
    //--------------------
    function setupHWListeners() {
        let homeworkShareButtons = document.querySelectorAll('#homework-share');
        if(homeworkShareButtons && homeworkShareButtons.length) {
            homeworkShareButtons.forEach((i) => {
                i.addEventListener('click', copyHWToClipboard);
            });
        }
    }

    setupHWListeners();
    window.setupHWListeners = setupHWListeners;



    function copyHWToClipboard(e) {
        var value = e.target.getAttribute('data-url')
        console.log(value, e.target)
        if(!value || value == 'null') {
            value = e.target.parentElement.getAttribute('data-url');
            console.log(value)
        }
        var homeworkShareText = document.querySelector('#homework-share span:not(.icon)');
        navigator.clipboard.writeText(value)
        homeworkShareText.textContent = 'Copied';
        homeworkShare.classList.add('copied');
    }

    let copyAI = document.querySelector('.copy-ai-message');
    if(copyAI) {
        copyAI.addEventListener('click', copyMessageToClipboard);
    }

    function copyMessageToClipboard() {
        navigator.clipboard.writeText("Hi, we use Teach Active for our lessons, and its AI Lesson Assistant is being blocked on our network.\nCould you please add these two websites to our safe list (allowlist) in the web filter and firewall?\nhttps://www.teachactive.org \nhttps://www.chatbase.co");
        copyAI.textContent = 'Copied';
    }

    //--------------------
    // Teachers
    //--------------------
    var settings = {
        base: currentLocation.protocol + '//' + currentLocation.hostname + '/wp-json/lessons/v2/',
        nonce: jQuery('#wp-nonce').val()
    }

    var endpointTeachers = document.querySelector('#teachers');

    let teacherEditToggles = document.querySelectorAll('[data-role="edit-teacher-toggle"]');
    if(teacherEditToggles) {
        teacherEditToggles.forEach((i) => {
            i.addEventListener('click', open_teacher_edit);
        })
    }
    let teacherRemoveToggles = document.querySelectorAll('[data-role="remove-teacher-toggle"]');
    if(teacherRemoveToggles) {
        teacherRemoveToggles.forEach((i) => {
            i.addEventListener('click', open_teacher_remove);
        })
    }

    // let teacherEmailInputs = document.querySelectorAll('.teacher-email');
    // if(teacherEmailInputs) {
    //     teacherEmailInputs.forEach((i) => {
    //         i.addEventListener('blur', checkforDomain)
    //     })
    // }

    function checkforDomain(e) {
        let form = e.target.closest('form');
        let domain = form.school_domain.value;
        if(!domain) {
            return true;
        }
        let thisVal = e.target.value;
        console.log(form, domain, thisVal, thisVal.includes(domain));
        if(!thisVal.includes(domain)) {
            e.target.classList.add('error');
        } else {
            e.target.classList.remove('error');
        }
    }

    if (endpointTeachers) {
        jQuery('.form-validate').each(function () {
            jQuery(this).on('submit', function (e) {
                e.preventDefault();
                var $form = jQuery(this);

                var endpoint = $form.attr('action');
                var method = $form.attr('method');
                var thedata = $form.serializeArray();
                console.log(endpoint);

                $form.parent().find('.status').html('');

                var $req = doAjax(endpoint, thedata, $form, method);

                $req.success(function (data) {
                    var html = getSuccessMessage(['Teacher Updated']);
                    $form.parent().find('.status').html(html);
                    setTimeout(function () {
                        window.location.reload();
                    }, 1500);
                });

                $req.error(function (xhr, textStatus, errorThrown) {
                    var errors = xhr.responseJSON;
                    console.log(xhr, errors)
                    var error_html = getErrorMessage(errors.errors);
                    $form.prepend(error_html);
                });
            })
        });

        // toggle enable / disable meta on teacher user
        jQuery('body').on('change', 'input:checkbox.toggle', function () {
            var $this = jQuery(this);
            var uid = $this.attr('name');
            var enabled = ($this.is(':checked') ? 1 : 0);
            toggleTeacher($this, uid, enabled);
        });

        jQuery('.modal-toggle').on('click', openModal);

        var cancelButton = document.querySelector('[data-role="cancel"]');
        if (cancelButton) {
            cancelButton.addEventListener('click', closeRemoveModal);
        }
    }

    function open_teacher_edit(e) {
        let parent = e.target.closest('tr');
        var form = document.querySelector('#edit-teacher-form');
        var uid = parent.getAttribute('data-id');
        var firstname = parent.getAttribute('data-firstname');
        var lastname = parent.getAttribute('data-lastname');
        var email = parent.getAttribute('data-email');

        form.querySelector('input[name="email"]').value = email;
        form.querySelector('input[name="first_name"]').value = firstname;
        form.querySelector('input[name="last_name"]').value = lastname;
        form.querySelector('input[name="user_id"]').value = uid;

        form.classList.add('open');
    }

    function open_teacher_remove(e) {
        let id = e.target.getAttribute('data-user-id');
        let form = document.querySelector('#remove-teacher-form');
        form.classList.add('open');
        form.querySelector('input[name="id"]').value = id;
    }

    function doAjax(endpoint, thedata, $form, method) {

        if ($form === undefined) {
            $form = null;
        }

        if (method === undefined) {
            method = 'GET';
        }

        thedata._wpnonce = settings.nonce;
        var requrl = settings.base + endpoint;
        var args = {
            url: requrl,
            type: method,
            data: thedata,
            cache: false,
        };

        args.beforeSend = function (xhr) {
            if ($form) {
                $form.find('.form-errors').remove();
                $form.addClass('form-loading');
            }
        }

        var $req = jQuery.ajax(args);

        $req.always(function (data, textStatus, xhr) {
            if ($form) {
                $form.removeClass('form-loading');
            }
        });

        return $req;
    }

    function getSuccessMessage(msgs) {
        var html = '<div class="form-success ajax-success"><ul>';
        jQuery.each(msgs, function (k, v) {
            html += '<li>' + v + '</li>';
        });
        html += '</ul></div>';
        return html;
    }

    function getErrorMessage(msgs) {
        var html = '<div class="form-errors ajax-errors"><ul>';
        console.log(msgs)
        jQuery.each(msgs, function (k, v) {
            html += '<li>' + v + '</li>';
        });
        html += '</ul></div>';
        return html;
    }

    function toggleTeacher($trigger, uid, enabled) {
        var endpoint = 'toggle-teacher/';

        var thedata = {
            'id': uid,
            'enabled': enabled
        };

        $trigger.prop('disabled', true);
        $trigger.parent().append('<span class="spinner"></span>'); // style this to show loading

        var $req = doAjax(endpoint, thedata, null, 'POST');

        $req.success(function (data) {
            $trigger.prop('disabled', false);
            $trigger.parent().find('.spinner').remove();
        });

        $req.error(function (xhr, textStatus, errorThrown) {
            console.log(textStatus);
            console.log(errorThrown);
        });
    }

    /** taster on dashboard */

    let tasterTrigger = document.querySelector('#request_taster');
    if(tasterTrigger) {
        tasterTrigger.addEventListener('click', submit_taster_request);
    }

    function submit_taster_request(e) {
        let subject = e.target.getAttribute('data-subject');
        let school_id = e.target.getAttribute('data-user-id');
        let formdata =  new FormData();
        formdata.append('action', 'request_taster');
        formdata.append('userID', school_id);
        formdata.append('lessonType', subject);
         fetch(teachactive.ajaxurl, {
            method: 'POST',
            body: formdata
        }).then(response => response.json())
        .then((jsonData) => {
            console.log(jsonData)
            let message = jsonData.success ? 'Thank you for applying. One of our team members will contact you.' : 'There was a problem submitting your request. Please try again later or get in touch with us directly';
            document.querySelector('.upgrade .inner').insertAdjacentHTML('beforeend', '<p>'+message+'</p>');
        })
    }

    let upgradeButtons = document.querySelectorAll('[data-target=".upgrade"]');
    if(upgradeButtons) {
        upgradeButtons.forEach((i) => {
            i.addEventListener('click', set_the_subject);
        })
    }

    function set_the_subject(e) {
        let subject = e.target.getAttribute('data-subject');
        document.querySelector('#request_taster').setAttribute('data-subject', subject);
    }

}